import { v4 as uuidv4 } from 'uuid';

export function ProductName(props) {
	return {
		componentName: 'ProductName',
		componentId: uuidv4(),
		props: {
			showBrandName: false,
			showProductReference: false,
			showSku: false,
			blockClass: 'product-name-xd',
			mzProductName: 'Calça selva noturna roupa de inverno',
			...props,
		},
		childrenComponents: [],
	};
}
